module.exports = ".whatsNew {\r\n    margin: auto;\r\n    width: 50%;\r\n    padding: 10px;\r\n}\r\n\r\nul{\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n.toggleImg {\r\n    height: 15px;\r\n    width: 15px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/header/whats-new/whats-new.component.css
// module id = ./src/app/main-content/header/whats-new/whats-new.component.css
// module chunks = main